import { InformationField } from '../../../components/shared';
import useStyles from '../style';
import { formatNumberOrReturnZero } from '../../../utils/common-methods';
import { Box } from '@mui/material';

const SublocationSummaryField = ({ content, isCompact }) => {
  const classes = useStyles();

  if (isCompact) {
    return (
      <Box
        data-testid="summary"
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '4px 16px',
          px: 1,
          py: 0.75,
          backgroundColor: 'inherit',
        }}
      >
        {content &&
          content?.length > 0 &&
          content.map((element, index) => {
            const { label, value, priceIcon } = element;
            return (
              <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: '4px', whiteSpace: 'nowrap' }}>
                <InformationField
                  data-testid="revenueSummary"
                  value={`${label}:`}
                  variant="subtitle7"
                  sx={{ fontSize: '0.75rem', fontWeight: 600 }}
                />
                <InformationField
                  value={priceIcon ? `${priceIcon} ${formatNumberOrReturnZero(value)}` : value}
                  variant="subtitle4"
                  sx={{ fontSize: '0.82rem', fontWeight: 700 }}
                />
              </Box>
            );
          })}
      </Box>
    );
  }

  return (
    <Box className={classes.summaryBackground} data-testid="summary" sx={{ width: '100%', px: 1.5, py: 1 }}>
      {content &&
        content?.length > 0 &&
        content.map((element, index) => {
          const { label, value, priceIcon } = element;
          return (
            <Box
              key={index}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                gap: 1,
                py: 0.25,
              }}
            >
              <InformationField
                data-testid="revenueSummary"
                value={label}
                variant="subtitle4"
                sx={{ fontSize: '0.8rem', fontWeight: 600, lineHeight: 1.35, flex: 1 }}
              />
              <InformationField
                value={priceIcon ? `${priceIcon} ${formatNumberOrReturnZero(value)}` : value}
                variant="subtitle4"
                sx={{ fontSize: '0.875rem', fontWeight: 700, lineHeight: 1.2, whiteSpace: 'nowrap', flexShrink: 0 }}
              />
            </Box>
          );
        })}
    </Box>
  );
};

export default SublocationSummaryField;
